import { render } from "./BaseInput.vue?vue&type=template&id=0454d048&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=0454d048&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0454d048"]])

export default __exports__